function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
const SvgUnPin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  "data-animate": props.isAnimate || false,
  "data-interactive": props.animateOnInteraction || false
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: props.color || 'currentColor',
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14.45 6.55 9.23 1.33l-.016 1.348A44.371 44.371 0 0 1 7.22 4.506l-.25.12m-.438 4.93L2.245 5.27c.73.368 2.002.383 3.453-.174l1.274-.468m-.44 4.93 4.199 4.198c-.35-.756-.395-2.04.105-3.511l.557-1.197m-4.86.51-4.438 4.438M4.366 2.02l2.606 2.606m7.293 7.293-2.872-2.873m-4.421-4.42 4.42 4.42"
}));
export default SvgUnPin;